import { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import Mockup from "../../assets/mockup.jpg";
import CadastroPagamento from ".";
import {
  LoadClienteData,
  LoadDadosCartao,
  LoadPlanoCliente,
  VerifyClientePlano,
} from "../../store/actions/usuario";
import { useSelector } from "react-redux";
import FuncionarioEmpresa from "./funcionarioEmpresa";
import TrocarDadosCartao from "./trocarCartao";
import Loading from "../../components/Loading";
import DadosDependente from "./dadosDependente";
import AlertComponent from "../../components/AlertComponent";
import { toCurrency } from "../../helpers/toCurrency";
import { FindPlanoByID } from "../../store/actions/plano";

function CadastroPagamentoApp() {
  const { plano, clienteLoad, assinaturaLoad } = useSelector(
    (state) => state.usuario
  );

  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const [newPlano, setNewPlano] = useState(null);
  const [diaVencimento, setDiaVencimento] = useState(null);

  async function loadClienteData() {
    await LoadClienteData({ empresa: true, contratante: true });
    await LoadPlanoCliente({ plano: true });
    await LoadDadosCartao({ getnet: true });
  }

  /**
   * @param {AbortController} abortController
   */
  async function load(abortController) {
    try {
      setLoading(true);
      setLoadError(false);

      const verificationOrAssinatura = await VerifyClientePlano(
        abortController
      );

      if (verificationOrAssinatura?.update) {
        if (
          verificationOrAssinatura.newPlanoId &&
          verificationOrAssinatura.redirectToPayment
        ) {
          const newPlano = await FindPlanoByID(
            verificationOrAssinatura.newPlanoId,
            abortController
          );

          setNewPlano({ ...newPlano });

          if (verificationOrAssinatura.diaVencimento) {
            setDiaVencimento(verificationOrAssinatura.diaVencimento);
          }
        }
      }

      await loadClienteData();
    } catch (error) {
      if (
        !error?.code ||
        error.code !== "ERR_CANCELED" ||
        (error?.config?.url &&
          error?.response?.status &&
          error.response.status !== 404 &&
          error.config.url !== "/api/v2/app/assinatura/verify")
      ) {
        setLoadError(true);
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const abortController = new AbortController();

    load(abortController);

    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <div
      style={{
        overflowY: "scroll",
        height: "100%",
      }}
    >
      {loading ? (
        <div style={{ height: "70%" }}>
          <Loading loading={loading} />
        </div>
      ) : (
        <>
          {clienteLoad.tipoConta === "D" ? (
            <DadosDependente data={clienteLoad} plano={plano} />
          ) : (
            <>
              {clienteLoad.empresaId ? (
                <FuncionarioEmpresa data={clienteLoad} plano={plano} />
              ) : (
                <>
                  {assinaturaLoad.getnet ? (
                    <TrocarDadosCartao
                      usuario={clienteLoad}
                      plano={plano}
                      assinatura={assinaturaLoad}
                      loadActions={loadClienteData}
                    />
                  ) : (
                    <Grid container spacing={2} style={{ marginBottom: 20 }}>
                      <Grid item sm={7} xs={12}>
                        <div
                          style={{
                            display: "flex",
                            alignContent: "center",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div style={{ width: "80%" }}>
                            <div style={{ marginTop: 15 }}>
                              <h3
                                style={{
                                  fontWeight: "700",
                                  fontSize: 30,
                                  margin: 0,
                                  marginTop: 20,
                                  color: "#191919",
                                }}
                              >
                                {!!newPlano ? newPlano.nome : "Plano família"}
                              </h3>

                              <h4
                                style={{
                                  fontWeight: "400",
                                  fontSize: 16,
                                  margin: 0,
                                  color: "#191919",
                                }}
                              >
                                Por apenas{" "}
                                <b style={{ color: "#4f8d96" }}>
                                  {toCurrency(
                                    !!newPlano ? newPlano.valor : 69.9
                                  )}
                                </b>{" "}
                                ao mês
                              </h4>
                            </div>

                            <CadastroPagamento
                              loadActions={loadClienteData}
                              planoId={newPlano?.id}
                              diaVencimento={diaVencimento}
                            />
                          </div>
                        </div>
                      </Grid>
                      <Grid item sm={5} xs={12}>
                        <div
                          style={{
                            display: "flex",
                            alignContent: "center",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={Mockup}
                            alt="Mockup"
                            style={{ marginTop: 50, width: 250 }}
                          />
                        </div>
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

      {loadError && (
        <AlertComponent
          type="error"
          message="Não foi possível carregar as informações do seu plano"
          timeout={4000}
        />
      )}
    </div>
  );
}

export default CadastroPagamentoApp;
